import { NavLink } from '@mantine/core'
import { IconLogout } from '@tabler/icons-react'
import { useMsal } from '@azure/msal-react'
import classes from 'shared/src/components/app-shell/user-menu/user-menu.module.css'

export const LogoutLink = () => {
  const { instance } = useMsal()

  const handleLogout = () => {
    // Perform any additional logout logic here if needed
    instance.logoutRedirect()
  }

  return (
    <NavLink
      label='Logout'
      leftSection={<IconLogout />}
      classNames={{
        root: classes.navLink,
        section: classes.iconSection,
      }}
      onClick={() => handleLogout()}
    />
  )
}
